import { authFetch } from 'api/auth/authFetch'
import { validateDuplicatesTitles, removeEmptyRowsFromTitle } from 'components/Body/data-entry/AudioVisual/programmeDetailsUtils'
import { setAreEpisodeLanguagesInvalid, setAreEpisodeTitlesInvalid, setEpisodeTitles } from 'components/Body/data-entry/AudioVisual/store/actions'
import { confirmDialog } from 'primereact/confirmdialog'
import { confirmPopup } from 'primereact/confirmpopup'
import { isEligibleContributionType, getEligibleContributions, splitPercentageEvenly, calculateMinutesWorked } from 'modules/data-entry/AudioVisual/contributionUtils'
import { ContactTypeIds, ContributionTypeIds } from 'modules/Constants'


export const validateProgrammeChanges = async (toast, dispatch, resultsDataForEdit, primaryTitle, programmeTypeId, formatId, primaryCountry, episodeData, episodePrimaryTitle, episodeValidationRequired, programmeGuid, programmeUrl) => {
    let isValid = true

    if (resultsDataForEdit) {
        // Program Main title should not be empty
        if (!primaryTitle || !primaryTitle.title.trim()) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Primary Title is required' })
            isValid = false
        }
        // Master IDA ID should be numeric
        if (resultsDataForEdit.idAid && isNaN(resultsDataForEdit.idAid)) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Master IDA should be numeric' })
            isValid = false
        }
        if (resultsDataForEdit.idAid && String(resultsDataForEdit.idAid).length !== 12) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Master IDA must be 12 characters long' })
            isValid = false           
        }
        // Check for duplicate IDA
        if (resultsDataForEdit.idAid) {
            const duplicateIdaMessage = await checkDuplicateIda(resultsDataForEdit.idAid, programmeUrl, true,  programmeGuid,null)
            if (duplicateIdaMessage) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: duplicateIdaMessage })
                isValid = false
            }
        }
        // Programme Type should be selected
        if (!programmeTypeId) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Programme Type is required' })
            isValid = false
        }
        // Format should be selected
        if (!formatId) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Format is required' })
            isValid = false
        }
        else {
            if (formatId === 1 || formatId === 5) {
                if (!resultsDataForEdit.animeOrLive) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Anime/Live is required for Film Type' })
                    isValid = false
                }
            }
        }
        // Language should be selected
        if (!resultsDataForEdit.languageId) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Language is required' })
            isValid = false
        }
        // Primary Country should be selected
        if (!primaryCountry || !primaryCountry.countryId) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Primary Country is required' })
            isValid = false
        }        

        if (episodeValidationRequired) {
            isValid = isValid && await validateEpisodeDetails(toast, dispatch, episodeData, episodePrimaryTitle, programmeGuid, programmeUrl)
        }       

    }

    return isValid
}

export const validateEpisodeDetails = async (toast, dispatch, episodeData, episodePrimaryTitle, programmeGuid,programmeUrl) => {
   
    let isValid = true    

    if (episodeData) {

        if (!episodePrimaryTitle || episodePrimaryTitle.title.trim() === "") {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Episode Title is Mandatory' })
            isValid = false
        }

        if (episodeData.number === "" || episodeData.number < 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Episode Number is Mandatory' })
            isValid = false
        }

        if (episodeData.series === "" || episodeData.series < 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Series Number is Mandatory' })
            isValid = false
        }

        if (episodeData.durationMinutes === "" || episodeData.durationMinutes < 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Duration is Mandatory' })
            isValid = false
        }

        if (episodeData.yearOfProduction === "" || episodeData.yearOfProduction <= 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Year Produced is Mandatory' })
            isValid = false
        }  
        // Master IDA ID should be numeric
        if (episodeData.idaCode && isNaN(episodeData.idaCode)) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Episode IDA should be numeric' })
            isValid = false
        }
        //IDA code must be of length 12 characters
        if (episodeData.idaCode && String(episodeData.idaCode).length !== 12) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Episode IDA must be 12 characters long' })
            isValid = false
        }
        // Check for duplicate IDA
        if (episodeData.idaCode) {
            const duplicateIdaMessage = await checkDuplicateIda(episodeData.idaCode, programmeUrl, false, programmeGuid, episodeData.id)
            if (duplicateIdaMessage) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: duplicateIdaMessage })
                isValid = false
            }
        }

        // Perform validation for titles
        if (episodeData.titles) {
            isValid = isValid && validateTitleChanges(toast, dispatch, episodeData.titles)
        }
    }
    else {
        isValid = false
    }

    return isValid
}

export const validateEpisodeListDetails = async (toast, programmeData, episodeList,programmeUrl) => {
    // Perform validation checks
    // Return true if valid, false otherwise
    // Uses AudioVisualResultModel field names: episodeTitle, episodeNumber, episodeSeries, episodeDuration, episodeYear, episodeIda, episodeId
    let isValid = true
    const idaCodes = new Set()

    for (const episodeData of Object.values(episodeList)) {
        // Episode title should not be empty
        if (!episodeData.episodeTitle || episodeData.episodeTitle.trim() === "") {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Episode Title is Mandatory' })
            isValid = false
        }

        if (episodeData.episodeNumber === null || episodeData.episodeNumber < 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Episode Number is Mandatory' })
            isValid = false
        }

        if (episodeData.episodeSeries === null || episodeData.episodeSeries < 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Series Number is Mandatory' })
            isValid = false
        }
        if (episodeData.episodeDuration === null || episodeData.episodeDuration < 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Duration is Mandatory' })
            isValid = false
        }
        if (episodeData.episodeYear === null || episodeData.episodeYear <= 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Year Produced is Mandatory' })
            isValid = false
        }
        // Episode IDA should be numeric
        if (episodeData.episodeIda && isNaN(episodeData.episodeIda)) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Episode IDA should be numeric' })
            isValid = false
        }
        // Check for duplicate IDA
        if (episodeData.episodeIda) {
            if (idaCodes.has(episodeData.episodeIda)) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'IDA already exists' })
                isValid = false
            } else {
                idaCodes.add(episodeData.episodeIda)
            }
            if (episodeData.episodeIda && String(episodeData.episodeIda).length !== 12) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'IDA must be 12 characters long' })
                isValid = false
            }
            // Check for duplicate IDA in the database
            const duplicateIdaMessage = await checkDuplicateIda(episodeData.episodeIda, programmeUrl, false, programmeData.id, episodeData.episodeId)
            if (duplicateIdaMessage) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: duplicateIdaMessage })
                isValid = false
            }
        }
    }
    return isValid
}

export const validateTitleChanges = (toast, dispatch, titles) => {    
    let isValid = true
    let primaryTitle = titles && titles.length > 0 && titles?.find(title => title.titleTypeId === 1)
    titles = titles && titles.length > 0 && titles?.filter(title => title.titleTypeId !== 1)
    const emptyRowsRemoved = removeEmptyRowsFromTitle(titles)
    dispatch(setEpisodeTitles(emptyRowsRemoved))   

    try {
        validateDuplicatesTitles(emptyRowsRemoved, primaryTitle) // Throws an error if duplicates are found
    } catch (error) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: error.message })
        isValid = false
    }

    // Check if all titles have title filled
    const invalidTitles = emptyRowsRemoved.map((title, index) => {
        if (!title.title) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: `Title at row ${index + 1} must have both language and title filled` })
            return true
        }
        return false
    })
    dispatch(setAreEpisodeTitlesInvalid(invalidTitles))
    if (invalidTitles.some(invalid => invalid)) {
        isValid = false
    }
    // Check if all titles have both language and title filled
    const invalidLanguages = emptyRowsRemoved.map((title, index) => {
        if (!title.languageId) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: `Language at row ${index+1} must have both language and title filled` })
            return true
        }
        return false
    })
    dispatch(setAreEpisodeLanguagesInvalid(invalidLanguages))
    if (invalidLanguages.some(invalid => invalid)) {
        isValid = false
    }


    // If all validations pass
    return isValid
}

// returns a bool indicating whether the new format is valid
export const validateChangeProgrammeFormat = (newFormatId, programmeData) => {
    
    // We get programme data just to keep the interface clean,
    // but we only care about the episode count

    switch (newFormatId.sapCode) {
        case "FF":
        case "TF":
            // The rule is we do not allow when multiple episodes
            return (Object.keys(programmeData.episodes).length <= 1)
        default:
            return true
    }

}

export const checkDuplicateIda = async (idaCode, programmeUrl, isProgramme, programmeId, episodeId) => {
    let endpoint = `${programmeUrl}/${programmeId}/CheckDuplicateIda?idaNumber=${idaCode}`
    if (!isProgramme) {
        endpoint = `${programmeUrl}/${programmeId}/Episodes/${episodeId}/CheckDuplicateIda?idaNumber=${idaCode}`
    }
    try {
        var response = await authFetch(endpoint)
        var isDuplicate = await response.json()

        if (isDuplicate === true) {
            return 'IDA already exists'
        }
    } catch (error) {
        console.error('Error:', error)
    }
    return undefined
}

/**
 * Contribution validation result types
 */
export const ContributionValidationResult = {
    VALID: 'valid',           // Total = 100%, save allowed
    LESS_THAN_100: 'lessThan100',  // Total < 100%, save blocked
    GREATER_THAN_100: 'greaterThan100', // Total > 100%, save blocked
    DURATION_INVALID: 'durationInvalid',
    DUPLICATE_FOUND: 'duplicateFound' //Contribution with same contribution type already exists
}

/**
 * Validates contribution percentages for an episode.
 * Returns validation result with status and appropriate message.
 * Excludes contributions marked for deletion from the calculation.
 *
 * @param {Object} episodeData - The episode data containing contributions
 * @param {boolean} hasContributionChanges - Whether there are pending contribution changes
 * @param {boolean} hasDeletedContributions - Whether there are contributions marked for deletion
 * @returns {Object} - { result: ContributionValidationResult, totalPercentage: number }
 */
export const validateContributionPercentages = (episodeData, hasContributionChanges, hasDeletedContributions = false) => {
    // Only validate duration when there are no contribution changes or deletions
    if (!hasContributionChanges && !hasDeletedContributions) {
        const contributions = episodeData?.contributions
        if (contributions && Object.keys(contributions).length > 0) {
            const contributionsArray = Object.values(contributions)
            const activeContributions = contributionsArray.filter(contribution => !contribution.isDeleted)
            
            // Validate duration: sum of contribution minutes should match episode duration
            if (episodeData.durationMinutes > 0 && activeContributions.length > 0) {
                const totalContributionMinutes = activeContributions.reduce((sum, contribution) => {
                    const minutes = parseFloat(contribution.minutes) || 0
                    return sum + minutes
                }, 0)

                const roundedTotalMinutes = Math.round(totalContributionMinutes * 100) / 100
                const roundedDuration = Math.round(episodeData.durationMinutes * 100) / 100

                if (roundedTotalMinutes !== roundedDuration) {
                    return { result: ContributionValidationResult.DURATION_INVALID, totalPercentage: 100, totalMinutes: roundedTotalMinutes, episodeDuration: roundedDuration }
                }
            }
        }
        return { result: ContributionValidationResult.VALID, totalPercentage: 100 }
    }

    const contributions = episodeData?.contributions
    if (!contributions || Object.keys(contributions).length === 0) {
        return { result: ContributionValidationResult.VALID, totalPercentage: 0 }
    }

    // Calculate total percentage across all contributions, excluding deleted ones
    const contributionsArray = Object.values(contributions)
    const totalPercentage = contributionsArray
        .filter(contribution => !contribution.isDeleted)
        .reduce((sum, contribution) => {
            const percentage = parseFloat(contribution.percentage) || 0
            return sum + percentage
        }, 0)

    // Round to 2 decimal places to avoid floating point issues
    const roundedTotal = Math.round(totalPercentage * 100) / 100

    if (roundedTotal === 100) {
        return { result: ContributionValidationResult.VALID, totalPercentage: roundedTotal }
    } else if (roundedTotal < 100) {
        return { result: ContributionValidationResult.LESS_THAN_100, totalPercentage: roundedTotal }
    } else {
        return { result: ContributionValidationResult.GREATER_THAN_100, totalPercentage: roundedTotal }
    }
}

/**
 * Validates contribution Duplicates for an episode.
 * Returns validation result with status and appropriate message.
 * Excludes contributions marked for deletion from validation.
 *
 * @param {Object} episodeData - The episode data containing contributions *
 * @returns {Object} - { result: ContributionValidationResult }
 */
export const validateDuplicateContributions = (episodeData) => {
    const contributions = episodeData?.contributions

    if (!contributions || Object.keys(contributions).length === 0) {
        return {
            result: ContributionValidationResult.VALID
        }
    }

    const activeContributions = Object.values(contributions)
        .filter(contribution => !contribution.isDeleted)

    const seen = new Set()
    const duplicates = []

    activeContributions.forEach(contribution => {
        const contactId = contribution.contactId
        const contributionTypeId = contribution.contributionTypeId

        // Skip incomplete records if desired
        if (!contactId || !contributionTypeId) {
            return
        }

        const key = `${contactId}_${contributionTypeId}`

        if (seen.has(key)) {
            duplicates.push({
                contactId,
                contributionTypeId
            })
        } else {
            seen.add(key)
        }
    })

    if (duplicates.length > 0) {
        return {
            result: ContributionValidationResult.DUPLICATE_FOUND,
            duplicates
        }
    }

    return {
        result: ContributionValidationResult.VALID
    }
}

/**
 * Gets the dialog configuration for contribution validation error
 *
 * @param {string} validationResult - The result from validateContributionPercentages
 * @param {number} totalPercentage - The calculated total percentage
 * @returns {Object|null} - Dialog configuration or null if valid/no dialog needed
 */
export const getContributionValidationDialogConfig = (validationResult, totalPercentage) => {
    switch (validationResult) {
        case ContributionValidationResult.LESS_THAN_100:
            return {
                header: 'Validation Error',
                message: `The total episode contributions must equal 100%. Current total is ${totalPercentage}%. Please review and adjust the contribution percentages before saving.`
            }
        case ContributionValidationResult.GREATER_THAN_100:
            return {
                header: 'Validation Error',
                message: `The total episode contributions cannot exceed 100%. Current total is ${totalPercentage}%. Please review and adjust the contribution percentages before saving.`
            }
        case ContributionValidationResult.DURATION_INVALID:
            return {
                header: 'Validation Error',
                message: `The total episode duration must be equal to total minutes worked. Please review and adjust the minutes worked`
            }
        case ContributionValidationResult.DUPLICATE_FOUND:
            return {
                header: 'Validation Error',
                message: 'Duplicate contributions are not allowed. The same Contact and Contribution Type combination can only be added once.'
            }
        default:
            return null
    }
}

/**
 * Shows contribution validation error dialog
 */
export const showContributionValidationDialog = (dialogConfig) => {
    confirmDialog({
        message: dialogConfig.message,
        header: dialogConfig.header,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Continue editing',
        acceptClassName: 'p-button-warning',
        rejectVisible: false,
        accept: () => {}
    })
}

/**
 * Shows contribution change confirmation dialog before saving
 * @param {Function} onAccept - Callback when user clicks Yes
 * @param {Function} onReject - Optional callback when user clicks No
 */
export const showContributionChangeConfirmation = (onAccept, onReject) => {
    confirmDialog({
        message: 'Any undistributed money on this episode will now be re-apportioned. Do you want to continue?',
        header: 'Confirm Changes',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-warning',
        accept: onAccept,
        reject: onReject ?? undefined
    })
}

/**
 * Shows contribution deletion confirmation popup
 * @param {Event} event - The event that triggered the confirmation
 * @param {Function} onAccept - Callback when user clicks Yes
 * @param {Function} onReject - Optional callback when user clicks No (defaults to no action)
 */
//export const showContributionDeletionConfirmation = (event, onAccept, onReject) => {
//    // Use confirmDialog instead of confirmPopup to avoid stale target issues when chaining confirmations
//    confirmDialog({
//        message: 'You are about to delete contribution(s). Any undistributed money on this episode will now be re-apportioned. Do you want to continue?',
//        header: 'Confirm Deletion',
//        icon: 'pi pi-info-circle',
//        acceptClassName: 'p-button-danger',
//        accept: onAccept,
//        reject: onReject ?? undefined
//    })
//}

export const showContributionDeletionConfirmation = (event, episodeData, originalContributions, onAccept,onReject) => {
    const willReapportion = !hasOnlyNonEligibleContributionChanges(episodeData, originalContributions)
    const message = willReapportion
        ? 'You are about to delete contribution(s). Any undistributed money on this episode will now be re-apportioned. Do you want to continue?'
        : 'You are about to delete contribution(s). Do you want to continue?';

    confirmDialog({
        message,
        header: 'Confirm Deletion',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        accept: onAccept,
        reject: onReject ?? undefined
    })
}

/**
 * Validates a contribution row data
 * @param {Object} rowData - The contribution row data
 * @param {number} episodeDuration - The episode duration in minutes
 * @returns {Object} - Object containing validation errors (empty if valid)
 */
export const validateContributionRow = (rowData, episodeDuration = 0) => {
    const errors = {}
    const MAX_PERCENTAGE = 100
    const MAX_MINUTES = 1000

    // Contribution Name is mandatory
    if (!rowData.contributorName || rowData.contributorName === '') {
        errors.contributorName = 'Contributor Name is mandatory'
    }

    // Contribution Type is mandatory (also invalid if isSelectable is false)
    if (!rowData.contributionType || rowData.contributionType === '' || rowData.contributionType.isSelectable === false) {
        errors.contributionType = 'Contribution Type is mandatory'
    }

    // Percentage is mandatory
    const hasPercentage = rowData.percentage !== null && rowData.percentage !== undefined && rowData.percentage !== ''
    if (!hasPercentage) {
        errors.percentage = 'Percentage is mandatory'
    }

    // Minutes is mandatory
    const hasMinutes = rowData.minutes !== null && rowData.minutes !== undefined && rowData.minutes !== ''
    if (!hasMinutes) {
        errors.minutes = 'Minutes is mandatory'
    }

    // Validate percentage range
    if (hasPercentage) {
        if (rowData.percentage < 0) {
            errors.percentage = 'Percentage cannot be negative'
        } else if (rowData.percentage > MAX_PERCENTAGE) {
            errors.percentage = `Percentage cannot be greater than ${MAX_PERCENTAGE}%`
        }
    }

    // Validate minutes range
    if (hasMinutes) {
        if (rowData.minutes < 0) {
            errors.minutes = 'Minutes cannot be negative'
        } else if (rowData.minutes > MAX_MINUTES) {
            errors.minutes = `Minutes cannot be greater than ${MAX_MINUTES}`
        } else if (episodeDuration > 0 && rowData.minutes > episodeDuration) {
            errors.minutes = `Minutes cannot be greater than episode duration (${episodeDuration} min)`
        }
    }

    return errors
}

// Re-export from contributionUtils for backwards compatibility
export { isEligibleContributionType, getEligibleContributions } from 'modules/data-entry/AudioVisual/contributionUtils'

/**
 * Validates that eligible contributions don't have 0 percentage or 0 minutes.
 * Actor (ID=2) and Director (ID=7) are exempt from this validation.
 * @param {Object} episodeData - The episode data containing contributions
 * @returns {Object} - { isValid: boolean, message: string | null }
 */
export const validateContributionZeroValues = (episodeData) => {
    const contributions = episodeData?.contributions
    if (!contributions || Object.keys(contributions).length === 0) {
        return { isValid: true, message: null }
    }

    const contributionsArray = Object.values(contributions)
    const activeContributions = contributionsArray.filter(c => !c.isDeleted)

    for (const contribution of activeContributions) {
        const contributionTypeId = Number(contribution.contributionType?.id || contribution.contributionTypeId)

        // Skip non-eligible types (Actor=2, Director=7)
        if (!contributionTypeId || !isEligibleContributionType(contributionTypeId)) {
            continue
        }

        const percentage = parseFloat(contribution.percentage) || 0
        const minutes = parseFloat(contribution.minutes) || 0

        if (percentage === 0 || minutes === 0) {
            return {
                isValid: false,
                message: 'Contributions (except Actor and Director) must have percentage and minutes greater than 0'
            }
        }
    }

    return { isValid: true, message: null }
}

/**
 * Validates that Non-Eligible Contributors only have Actor or Director contribution types.
 * @param {Object} episodeData - The episode data containing contributions
 * @returns {Object} - { isValid: boolean, message: string | null }
 */
export const validateNonEligibleContributorTypes = (episodeData) => {
    const contributions = episodeData?.contributions
    
    if (!contributions || Object.keys(contributions).length === 0) {
        return { isValid: true, message: null }
    }

    const contributionsArray = Object.values(contributions)
    const activeContributions = contributionsArray.filter(c => !c.isDeleted)

    for (const contribution of activeContributions) {
        const contactTypeId = Number(contribution.contactTypeId)
        const contributionTypeId = Number(contribution.contributionType?.id || contribution.contributionTypeId)

        // Check if contact is Non-Eligible Contributor
        if (contactTypeId === ContactTypeIds.NonEligibleContributor) {
            // Must be Actor or Director
            if (contributionTypeId !== ContributionTypeIds.Actor && contributionTypeId !== ContributionTypeIds.Director) {
                return {
                    isValid: false,
                    message: 'Contribution Type for a Non-Eligible Contributor must be either Actor or Director'
                }
            }
        }
    }

    return { isValid: true, message: null }
}

/**
 * Finds a matching contribution scenario based on contribution types
 * @param {Array} contributions - Array of contribution objects
 * @param {Array} contributionScenarios - Array of contribution scenarios from assets
 * @returns {Object|null} - Matching scenario or null if no match
 */
export const findMatchingContributionScenario = (contributions, contributionScenarios) => {
    if (!contributions || !contributionScenarios || contributionScenarios.length === 0) {
        return null
    }

    // Get unique eligible contribution type IDs from contributions
    const eligibleContributions = getEligibleContributions(contributions)
    if (eligibleContributions.length === 0) {
        return null
    }

    const contributionTypeIds = [...new Set(eligibleContributions.map(c => Number(c.contributionTypeId)))]
    const sortedContributionTypeIds = contributionTypeIds.sort((a, b) => a - b)

    // Find scenario that matches exactly
    for (const scenario of contributionScenarios) {
        if (!scenario.splits || scenario.splits.length === 0) continue

        // Get unique contribution type IDs from scenario splits
        const scenarioTypeIds = [...new Set(scenario.splits.map(s => Number(s.contributionTypeId)))]
        const sortedScenarioTypeIds = scenarioTypeIds.sort((a, b) => a - b)

        // Check if arrays match exactly
        if (sortedContributionTypeIds.length === sortedScenarioTypeIds.length &&
            sortedContributionTypeIds.every((id, index) => id === sortedScenarioTypeIds[index])) {
            return scenario
        }
    }

    return null
}

/**
 * Compares two numeric values with tolerance for floating-point precision (2 decimal places)
 */
const valuesEqual = (a, b) => {
    const roundedA = Math.round((Number(a) || 0) * 100) / 100
    const roundedB = Math.round((Number(b) || 0) * 100) / 100
    return roundedA === roundedB
}

/**
 * Checks if a contribution has changes other than percentage/minutes
 */
const hasOtherChanges = (current, original) => {
    if (!original) return true
    // Compare fields that can be edited (excluding percentage and minutes)
    return current.contributionTypeId !== original.contributionTypeId ||
           current.contactId !== original.contactId ||
           current.contactNameLineNum !== original.contactNameLineNum
}

/**
 * Calculates auto percentages and minutes for contributions based on matched scenario.
 * Distributes remainder to last contributor of each type to ensure exact totals.
 * Returns { toUpdate, toRemove } - toRemove contains ids that should be removed from draft
 */
export const calculateAutoPercentages = (contributions, scenario, episodeDuration, originalContributions = {}) => {
    if (!contributions || !scenario?.splits) return { toUpdate: {}, toRemove: [] }

    const toUpdate = {}
    const toRemove = []

    // Convert original contributions to a lookup map by id
    const originalMap = Array.isArray(originalContributions)
        ? originalContributions.reduce((acc, c) => { acc[c.id] = c; return acc }, {})
        : originalContributions

    // Build scenario percentage map by type
    const scenarioPercentByType = scenario.splits.reduce((acc, split) => {
        const typeId = Number(split.contributionTypeId)
        acc[typeId] = (acc[typeId] || 0) + Number(split.percent)
        return acc
    }, {})

    // Group eligible contributions by type
    const byType = getEligibleContributions(contributions).reduce((acc, c) => {
        const typeId = Number(c.contributionTypeId)
        ;(acc[typeId] = acc[typeId] || []).push(c)
        return acc
    }, {})

    // Calculate percentages for eligible contributions
    Object.entries(byType).forEach(([typeId, contributors]) => {
        const totalPercent = scenarioPercentByType[Number(typeId)] || 0
        const percentages = splitPercentageEvenly(totalPercent, contributors.length)

        contributors.forEach((c, i) => {
            const newPercentage = percentages[i]
            const newMinutes = calculateMinutesWorked(newPercentage, episodeDuration)
            const original = originalMap[c.id] || {}
            const percentageMatchesOriginal = valuesEqual(original.percentage, newPercentage) && valuesEqual(original.minutes, newMinutes)

            if (percentageMatchesOriginal) {
                // Percentage/minutes match original - check if there are other changes
                if (hasOtherChanges(c, original)) {
                    // Other changes exist - update with original percentage/minutes to preserve them
                    toUpdate[c.id] = { ...c, percentage: original.percentage, minutes: original.minutes }
                } else {
                    // No other changes - can be removed from draft entirely
                    toRemove.push(c.id)
                }
            } else {
                // Percentage/minutes differ from original - update with new values
                toUpdate[c.id] = { ...c, percentage: newPercentage, minutes: newMinutes }
            }
        })
    })

    // Set non-eligible contributions to 0
    contributions.filter(c => c && !c.isDeleted && c.contributionTypeId && !isEligibleContributionType(c.contributionTypeId))
        .forEach(c => {
            const original = originalMap[c.id] || {}
            const matchesOriginal = valuesEqual(original.percentage, 0) && valuesEqual(original.minutes, 0)

            if (matchesOriginal) {
                if (hasOtherChanges(c, original)) {
                    toUpdate[c.id] = { ...c, percentage: 0, minutes: 0 }
                } else {
                    toRemove.push(c.id)
                }
            } else {
                toUpdate[c.id] = { ...c, percentage: 0, minutes: 0 }
            }
        })

    return { toUpdate, toRemove }
}

/**
 * Shows invalid contribution scenario dialog
 */
export const showInvalidContributionScenarioDialog = () => {
    confirmDialog({
        message: 'Not a valid Contribution Scenario',
        header: 'Invalid Scenario',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'OK',
        acceptClassName: 'p-button-warning',
        rejectVisible: false,
        accept: () => {}
    })
}

/**
 * Determines if contribution changes only affect non-eligible types (Actor/Director).
 * Returns true if all changes are to Actor/Director contributions only.
 * @param {Object} episodeData - Episode data with contributions
 * @param {Object} originalContributions - Original contributions before changes
 * @returns {boolean} - True if only Actor/Director contributions changed
 */
export const hasOnlyNonEligibleContributionChanges = (episodeData, originalContributions = {}) => {
    const contributions = episodeData?.contributions
    if (!contributions || Object.keys(contributions).length === 0) {
        return false
    }

    const contributionsArray = Object.values(contributions)

    // Check each contribution for changes
    for (const contribution of contributionsArray) {

        if (contribution.isDeleted) {
            const typeId = Number(contribution.contributionType?.id || contribution.contributionTypeId);

            // If deleted is Actor or Director → ignore it
            if (
                typeId === ContributionTypeIds.Actor ||
                typeId === ContributionTypeIds.Director
            ) {
                continue;
            }

            // If deleted is NOT Actor/Director → still matters
            return false;
        }

        const contributionTypeId = Number(contribution.contributionType?.id || contribution.contributionTypeId)

        // Skip if no contribution type
        if (!contributionTypeId) continue

        // Find original contribution
        const original = originalContributions[contribution.id] ||
            Object.values(originalContributions).find(c => c.id === contribution.id)

        // If this is a new contribution (no original)
        if (!original) {
            // Check if it's Actor or Director
            if (contributionTypeId !== ContributionTypeIds.Actor &&
                contributionTypeId !== ContributionTypeIds.Director) {
                // New contribution is NOT Actor/Director - this requires reapportionment
                return false
            }
        } else {
            // Existing contribution modified
            // Check if contribution type is Actor or Director
            if (contributionTypeId === ContributionTypeIds.Actor ||
                contributionTypeId === ContributionTypeIds.Director) {
                // Changes to Actor/Director are OK, continue checking others
                continue
            } else {
                // Check if eligible type contribution has changes
                const hasChanges =
                    contribution.contributionTypeId !== original.contributionTypeId ||
                    contribution.contactId !== original.contactId ||
                    contribution.contactNameLineNum !== original.contactNameLineNum ||
                    !valuesEqual(contribution.percentage, original.percentage) ||
                    !valuesEqual(contribution.minutes, original.minutes) ||
                    contribution.isDeleted !== original.isDeleted

                if (hasChanges) {
                    // Changes to eligible contribution type - requires reapportionment
                    return false
                }
            }
        }
    }

    // All changes are to Actor/Director only
    return true
}




